
import { Vue, Component, Watch } from 'vue-property-decorator';
import {
  Form,
  FormItem,
  Input,
  Cascader,
  Select,
  Option,
} from 'element-ui';
import { WSearchForm } from '@/types/course.d';
import api from '@/api/verify';

@Component({
  components: {
    Form,
    FormItem,
    Input,
    Select,
    Option,
    Cascader,
  },
})
export default class SearchForm extends Vue {
  // private rules: any = {
  //   status: [
  //     { required: true, message: '请输入审核状态', trigger: 'change' },
  //   ],
  // }

  private form: WSearchForm = {
    title: '',
    orgPid: '',
    status: null,
  };

  private org: any = [];

  private options: any = [
    {
      value: 1,
      label: '通过',
    },
    {
      value: 2,
      label: '未通过',
    },
  ]

  private statusOptions: any = [{
    value: 1,
    label: '全部',
  },
  {
    value: 2,
    label: '已拉黑',
  },
  ]

  public $refs!: {
    form: Form,
  };

  mounted() {
    api.getOrg().then((res: any) => {
      this.org = res;
      const otherOrg: any = { pid: 'queryRests', label: '其他' };
      this.org.push(otherOrg);
    });
  }

  /**
   * @author liangyongmou
   * @description  接收普通搜索的值
   * @param { searchValue } 普通搜索的值
   */
  setTitle(searchValue: any) {
    this.form.status = searchValue;
  }

  /**
   * @author liangyongmou
   * @desc 获取查询数据
   */
  getFormData() {
    this.$refs.form.validate((valid: boolean) => {
    });
    return this.form;
  }

  /**
   * @author liangyongmou
   * @desc 清空事件
   */
  handleClear() {
    this.$refs.form.resetFields();
  }
}
